import type { ReactNode } from "react";

/** A page's head (`.k-head`): the title with a quiet count, one optional thing at the right, and one line under it. */
export function PageHead({
  title,
  count,
  sub,
  eyebrow,
  right,
}: {
  title: ReactNode;
  count?: number | string;
  sub?: ReactNode;
  /** A small line above the title, such as the date. */
  eyebrow?: ReactNode;
  right?: ReactNode;
}) {
  return (
    <>
      {eyebrow ? <p className="k-eyebrow">{eyebrow}</p> : null}
      <div className="k-head">
        <h1 className="k-title">
          {title}
          {count !== undefined ? <small>{count}</small> : null}
        </h1>
        {right}
      </div>
      {sub ? <p className="k-sub">{sub}</p> : null}
    </>
  );
}

/** A section's head (`.k-gh`): its name, a quiet count and, at the right, one link. */
export function GroupHead({ title, count, action }: { title: ReactNode; count?: number | string; action?: ReactNode }) {
  return (
    <div className="k-gh">
      <h2>{title}</h2>
      {count !== undefined ? <b>{count}</b> : null}
      {action}
    </div>
  );
}
